import { Component } from '@angular/core';

@Component({
  selector: 'tv-root',
  templateUrl: './app.component.html',
  styleUrls: [
    './app.component.css'
  ]
})
export class AppComponent {
  title = 'My App';
}
